import React from "react";

const getExerciseCategory = (id) => {
    switch(id) {
        case 100:
        return "Foam Roll";

        case 125:
        return "Upper Body";

        case 150:
        return "Lower Body";

        case 200:
        return "Prep (Dynamic Warm Up)";

        case 225:
        return "Combination";

        case 250:
        return "Upper Body";

        case 275:
        return "Lower Body";

        case 300:
        return "Correct (Rehab/Prehab/Correctives)";

        case 325:
        return "Upper Body";

        case 330:
        return "Shoulder";

        case 335:
        return "Elbow";

        case 340:
        return "Wrist";

        case 350:
        return "Lower Body";

        case 355:
        return "Hip and Thigh";

        case 360:
        return "Knee";

        case 365:
        return "Ankle";

        case 375:
        return "Spine";

        case 380:
        return "Cervical";

        case 385:
        return "Thoracic";

        case 388:
        return "Lumbar";

        case 390:
        return "Diaphragm and Posture";

        case 395:
        return "Combinations";

        case 400:
        return "SLATE (Speed: Landing: Agility: Tempo: Explosion)";

        case 425:
        return "Core Elasticity";

        case 430:
        return "Vertical";

        case 431:
        return "Catch";

        case 432:
        return "Slam";

        case 433:
        return "Throw";

        case 434:
        return "Combination";

        case 440:
        return "Rotational";

        case 441:
        return "Catch";

        case 442:
        return "Slam";

        case 443:
        return "Throw";

        case 444:
        return "Combination";

        case 450:
        return "Lower Body Elasticity";

        case 455:
        return "Bilateral";

        case 456:
        return "Linear";

        case 457:
        return "Lateral and Rotational";

        case 465:
        return "Unilateral";

        case 466:
        return "Linear";

        case 467:
        return "Lateral and Rotational";

        case 475:
        return "Closed Chain Agility";

        case 480:
        return "Linear";

        case 481:
        return "Acceleration and Sprint";

        case 482:
        return "Sled";

        case 483:
        return "Ladders";

        case 484:
        return "Slideboard";

        case 485:
        return "Jump";

        case 488:
        return "Lateral and Combination";

        case 489:
        return "Acceleration and Sprint";

        case 490:
        return "Sled";

        case 491:
        return "Ladders";

        case 492:
        return "Slideboard";

        case 493:
        return "Jump";

        case 495:
        return "Open Chain Agility";

        case 500:
        return "Strength";

        case 525:
        return "Upper Body Strength";

        case 530:
        return "Bilateral Upper Body Push";

        case 531:
        return "Horizontal";

        case 532:
        return "Vertical";

        case 535:
        return "Bilateral Upper Body Pull";

        case 536:
        return "Horizontal";

        case 537:
        return "Vertical";

        case 540:
        return "Unilateral Upper Body Push";

        case 541:
        return "Horizontal";

        case 542:
        return "Vertical";

        case 545:
        return "Unilateral Upper Body Pull";

        case 546:
        return "Horizontal";

        case 547:
        return "Vertical";

        case 550:
        return "Arms";

        case 551:
        return "Biceps";

        case 552:
        return "Triceps";

        case 555:
        return "Combinations";

        case 560:
        return "Forearms";

        case 575:
        return "Lower Body Strength";

        case 580:
        return "Bilateral Lower Body Push";

        case 590:
        return "Bilateral Lower Body Pull";

        case 591:
        return "Vertical Tibia";

        case 592:
        return "Straight Leg";

        case 593:
        return "Bent Leg (Curl)";

        case 594:
        return "Bent Legged (Hyperextension)";

        case 600:
        return "Unilateral Lower Body Push";

        case 601:
        return "Vertical Supported";

        case 602:
        return "Horizontal Supported";

        case 603:
        return "Unsupported";

        case 610:
        return "Unilateral Lower Body Pull";

        case 611:
        return "Vertical Tibia";

        case 612:
        return "Straight Leg";

        case 613:
        return "Bent Leg (Curl)";

        case 614:
        return "Bent Legged (Hyperextension)";

        case 620:
        return "Upper/Lower body Strength Combination";

        case 625:
        return "Core Stability";

        case 635:
        return "Transverse (Anti-Rotation)";

        case 636:
        return "Lift or Chop";

        case 637:
        return "Pushouts";

        case 638:
        return "Landmine";

        case 639:
        return "Keiser Push Pull";

        case 640:
        return "Pull and Press Cable Bar";

        case 641:
        return "MedBall";

        case 645:
        return "Sagittal (Anti-Extension)";

        case 646:
        return "Rollouts";

        case 647:
        return "Handle";

        case 655:
        return "Combinations";

        case 660:
        return "Sagittal (Flexion Extension)";

        case 661:
        return "Combinations";

        case 662:
        return "Sequencing (mobility)";

        case 663:
        return "Anti-Lateral Flexion";

        case 664:
        return "Lateral Flexion";

        case 665:
        return "Sequencing (mobility)";

        case 675:
        return "Olympic and Weightlifting";

        case 680:
        return "Bilateral Push";

        case 685:
        return "Bilateral Pull";

        case 690:
        return "Bilateral Combination";

        case 695:
        return "Unilateral Push";

        case 700:
        return "Unilateral Pull";

        case 710:
        return "Unilateral Combination";

        case 730:
        return "Transverse (Rotational)";

        case 731:
        return "Lift or Chop";

        case 732:
        return "Landmine";

        case 733:
        return "MedBall";

        case 1000:
        return "Miscellaneous";

        default:
            return "Select";
      }
  }

export default getExerciseCategory;



// WEBPACK FOOTER //
// ./src/utils/ExerciseCategories.js